import React from "react";
import { Add } from "@mui/icons-material";
import AddUserSlider from "./addUserSlider/AddUserSlider";
import { Box, useTheme } from "@mui/material";
import { CircularProgress, Table, Text } from "@component";
import { tableCellData } from "./users.const";
import usersController from "./users.controller";
import {
  StyledBox,
  StyledButton,
  StyledContainer,
  StyledProgressContainer,
  StyledSearchInput,
} from "./users.style";

const Users: React.FC = () => {
  const theme = useTheme();
  const {
    loading,
    openModal,
    handleOpen,
    handleClose,
    filter,
    filterData,
    searchValue,
    userData,
    openDialog,
    handleDialogOpen,
    handleDialogClose,
    index,
    removeUser,
    deleteLoading,
  } = usersController();
  return (
    <StyledContainer>
      <StyledBox>
        <Box flex={1} m={theme.spacing(4)}>
          <Text variant="h4" color={theme.palette.primary.main}>
            Users
          </Text>
        </Box>
        <StyledSearchInput
          placeholder="Type something..."
          value={searchValue}
          onChange={(val) => filter(val?.target.value)}
        />
        <StyledButton
          onClick={() => handleOpen()}
          startIcon={<Add fontSize="large" />}
        >
          Add User
        </StyledButton>
        <AddUserSlider
          openDrawer={openModal}
          handleCloseIcon={handleClose}
          userId={index}
        />
      </StyledBox>
      {loading ? (
        <StyledProgressContainer>
          <CircularProgress size={40} color={"primary"} />
        </StyledProgressContainer>
      ) : (
        <Table
          tableCellData={tableCellData}
          tableData={filterData === null ? userData : filterData}
          navigationTo={"userDetails"}
          isButton
          buttonText="View"
          isDeleteButton
          isEditButton
          handleOpenDialog={(id) => {
            handleDialogOpen(id);
          }}
          openDialog={openDialog}
          handleCloseDialog={handleDialogClose}
          handleEdit={(id) => {
            handleOpen(id);
          }}
          handleDeleteDialog={removeUser}
          handleDeleteDialogLoading={deleteLoading}
        />
      )}
    </StyledContainer>
  );
};

export default Users;
